import type { ContactNoteEntity, ContactNoteType } from './entity_types/ContactNote';
import type { UserEntity } from './entity_types/User';
import { hFetch } from './hFetch';

export type GetContactNotesResponse = ContactNoteEntity & { user: UserEntity };
export const getContactNotes = (contactId: string) => {
  return hFetch<GetContactNotesResponse[]>({ url: `/api/contact_notes/${contactId}` });
};

type CreateContactNoteArgs = {
  contact_id: number;
  content: string;
  followup_at?: string;
  note_type: ContactNoteType;
};
export const createContactNote = (payload: CreateContactNoteArgs) => {
  return hFetch<{ status: string; message?: string }, CreateContactNoteArgs>({
    url: '/api/contact_notes',
    method: 'POST',
    payload,
  });
};

export const deleteContactNote = (noteId: number) => {
  return hFetch<{ status: string; message?: string }>({ url: `/api/contact_notes/${noteId}`, method: 'DELETE' });
};
